export function usePlaceholder(componentName: string) {
  const placeHolderNode = window.document.querySelector(`[data-placeholder="${componentName}"]`);
  if (placeHolderNode) {
    placeHolderNode.parentElement.removeChild(placeHolderNode);
    return true;
  }
  return false;
}
